/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Sellable_BadgeInputs */

const vi_product_sellable_badge = /** @type {(inputs: Product_Sellable_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cho phép bán`)
};

/**

* @param {Product_Sellable_BadgeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_sellable_badge = /** @type {((inputs?: Product_Sellable_BadgeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Sellable_BadgeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_sellable_badge(inputs)
});